module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAB4CAYAAADYDyODAAAAAXNSR0IArs4c6QAAADhJREFUOBFj/A8EDEDABCJAgEIGC9CIvyBzUBj/METgauggRQcr6Omd4WrXaDQh5x3U0ADln8EEAIFmY40hXQygAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/home-menu-bg-gradient.png
// module id = 513
// module chunks = 0